export default __webpack_public_path__ + "static/media/marker_home.6baa370b.svg";